import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

import Logo from './../../assets/img/logo.svg';


import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faXmark} from "@fortawesome/pro-light-svg-icons";

const Header = (props) => {

	if (!props.general) {
		return null;
	}

	const ctaButton = props.general.header.button;

	return <header className={"site-header" + (props.custom.scrolled ? " scrolled" : "")}>
		<div className="container">
			<div className="site-header-inner">
				<div className="row g-0 align-items-center">
					<div className="col-lg col-logo">

						<div className="site-branding">
							<Link to="/" className="logo">
								<img src={Logo} alt={props.general.title} />
							</Link>
							<a href="https://wise-materials.org/" target="_blank" className="addon-logo">
								{/*<img src={WiseLogo} alt="Wise" />*/}
								<span>A Wise Industrial Research Arena</span>
							</a>
						</div>


						<button onClick={props.toggleMenu} className={"menu-toggle " + (props.menu.menu_toggled ? " toggled" : "")}>
							<FontAwesomeIcon className={"icon"} icon={props.menu.menu_toggled ? faXmark : faBars} />
						</button>

					</div>
					<div className={"col-lg col-nav" + (props.menu.menu_toggled ? " open" : "")}>
						{props.menu.menus.main_menu &&
							<ul className="nav">
								{props.menu.menus.main_menu.items.filter(item => item.parent == 0).map((item, i) => {
									return <li key={item.id} className="nav-item">
										<SmartLink activeClassName="current" className="nav-link" url={item.url} target={item.target}>{item.title}</SmartLink>
									</li>
								})}




									<li className="nav-item nav-item--aside d-flex justify-content-end">
										<Link to={"/search"} url={ctaButton.url} className="button button-icon-only button-light me-1 d-none d-lg-flex"><i className="icon fal fa-search"></i></Link>
										{ctaButton &&
											<SmartLink url={ctaButton.url} className="button">{ctaButton.title}</SmartLink>
										}
									</li>
							</ul>
						}
					</div>
				</div>
			</div>

		</div>



	</header>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
			general: state.generalState.general,
			headerStyle: state.pageState.page?.headerStyle,
			custom: state.customState
		}
	},
	(dispatch) => {
		return {
			toggleMenu: () => {
				dispatch({
					type: 'MENU_TOGGLED'
				})
			},
			toggleSubMenu: (id, e) => {

				e.preventDefault();
				dispatch({
					type: 'SUBMENU_TOGGLED',
					id: id
				})
			},
		}
	}
)(Header);
